(function () {
  'use strict';

  var STORAGE_KEY = 'pagan_workshop_reading_list_v1';
  var config = window.PaganWishlistConfig || {};

  function parse(value, fallback) {
    try { return JSON.parse(value); } catch (error) { return fallback; }
  }

  function items() {
    var value = parse(localStorage.getItem(STORAGE_KEY), []);
    return Array.isArray(value) ? value.filter(function (item) {
      return item && typeof item.path === 'string' && item.path.indexOf('/blogs/') === 0;
    }) : [];
  }

  function saveItems(value) {
    var byPath = new Map();
    value.forEach(function (item) { if (item && item.path) byPath.set(item.path, item); });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(byPath.values())));
  }

  function articleFromButton(button) {
    return {
      path: button.dataset.articlePath,
      title: button.dataset.articleTitle,
      topics: String(button.dataset.articleTopics || '').split(',').filter(Boolean)
    };
  }

  function isSaved(path) {
    return items().some(function (item) { return item.path === path; });
  }

  function setStatus(message) {
    document.querySelectorAll('[data-reading-list-status]').forEach(function (status) {
      status.textContent = message || '';
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-reading-list-button]').forEach(function (button) {
      var saved = isSaved(button.dataset.articlePath);
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var icon = button.querySelector('.pw-reading-list__icon');
      var label = button.querySelector('[data-reading-list-label]');
      if (icon) icon.textContent = saved ? '♥' : '♡';
      if (label) label.textContent = saved ? 'Saved to Reading List' : 'Save to Reading List';
    });
  }

  async function proxy(payload) {
    if (!config.customerLoggedIn || !config.proxyUrl) return null;
    var response = await fetch(config.proxyUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(payload)
    });
    var result = await response.json().catch(function () { return {}; });
    if (!response.ok || !result.ok) throw new Error(result.error || 'Reading List sync failed');
    return result;
  }

  function track(name, article) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      article_path: article.path,
      article_title: article.title,
      article_topics: article.topics.join(',')
    });
  }

  async function toggle(button) {
    var article = articleFromButton(button);
    var saved = isSaved(article.path);
    var next = saved
      ? items().filter(function (item) { return item.path !== article.path; })
      : items().concat(article);
    saveItems(next);
    updateButtons();
    setStatus(config.customerLoggedIn ? 'Syncing with your account…' : 'Saved on this device. Sign in to keep it in your account.');
    track(saved ? 'reading_list_remove' : 'reading_list_add', article);

    if (!config.customerLoggedIn) return;
    try {
      await proxy({
        resource: 'article',
        action: saved ? 'remove' : 'add',
        articlePath: article.path,
        articleTitle: article.title,
        topics: article.topics
      });
      setStatus(saved ? 'Removed from your account Reading List.' : 'Saved in your account Reading List.');
    } catch (error) {
      console.error(error);
      setStatus('Saved on this device. Account sync will retry later.');
    }
  }

  async function syncAccount() {
    if (!config.customerLoggedIn || !config.proxyUrl) return;
    try {
      var server = await proxy({resource: 'article', action: 'get'});
      var local = items();
      var serverPaths = new Set((server.savedArticles || []).map(function (entry) { return String(entry).split('|')[0]; }));

      for (var index = 0; index < local.length; index += 1) {
        var article = local[index];
        if (!serverPaths.has(article.path)) {
          await proxy({
            resource: 'article',
            action: 'add',
            articlePath: article.path,
            articleTitle: article.title,
            topics: article.topics || []
          });
        }
      }

      (server.savedArticles || []).forEach(function (entry) {
        var parts = String(entry).split('|');
        if (!local.some(function (item) { return item.path === parts[0]; })) {
          local.push({path: parts[0], title: parts.slice(1).join('|') || 'Saved Pagan Knowledge guide', topics: []});
        }
      });
      saveItems(local);
      updateButtons();
    } catch (error) {
      console.error('Reading List sync failed', error);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-reading-list-button]');
    if (!button) return;
    event.preventDefault();
    toggle(button);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    syncAccount();
  });
}());
